import { generateClient } from 'aws-amplify/api';

export const client = generateClient();
